import AmexShopSmallEditorialCard from './AmexShopSmallEditorialCard';

export default AmexShopSmallEditorialCard;
